export default function ParametrageGeneralConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('parametrage.general');
}

ParametrageGeneralConfiguration.$inject = ['$translatePartialLoaderProvider'];
